import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';
import { ChangeSetArray } from '../connect-provider/models/changeset';
import { TreeItem } from '../connect-provider/models/tree-item';
import { ProviderChange } from '../connect-provider/models/providerchange';
import { IExternalSystem } from './IExternalSystem';


@Injectable()
export class ConnectProviderService {
    baseUrlExt = 'api/ExternalSystem/Provider';

    constructor(private _restApi: RestApi) { }

    getExternalSystems(): Observable<IExternalSystem[]> {
      return this._restApi.get(`${this.baseUrlExt}`);
    }

    getInfoById(id: string): Observable<IExternalSystem[]>{
      return this._restApi.get(`api/ExternalSystem/get-by-guid/${id}`);
    }

    getVirtualEntities(id: string): Observable<TreeItem[]>{
      return this._restApi.get(`api/ExternalSystem/virtualEntities/${id}`);
    }

    getReplicatedEntities(id: string): Observable<TreeItem[]>{
      return this._restApi.get(`api/ExternalSystem/replicatedEntities/${id}`);
    }

    getNextRunTime(id: string): Observable<any>{
      return this._restApi.get(`api/ExternalSystem/JobScheduler/${id}`);
    }

    getLog(id: string): Observable<any>{
      return this._restApi.get(`api/ExternalSystem/JobScheduler/log/${id}`);
    }

    postInfoProvider(params: ProviderChange): Observable<any>{
      return this._restApi.post(`api/ExternalSystem/Provider`, params);
    }

    postScheduleNow(id: string): Observable<any>{
      return this._restApi.post(`api/ExternalSystem/JobScheduler/ScheduleNow/${id}`, id);
    }

    postSchedule(jobScheduler: any):Observable<any>{
      return this._restApi.post(`api/ExternalSystem/JobScheduler`, jobScheduler);
    }
}
